import { render } from "./CompositeColorfulBar.vue?vue&type=template&id=2c274a51"
import script from "./CompositeColorfulBar.vue?vue&type=script&lang=js"
export * from "./CompositeColorfulBar.vue?vue&type=script&lang=js"

import "./CompositeColorfulBar.vue?vue&type=style&index=0&id=2c274a51&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__